"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var ga = _ref.ga,
      contrastClass = _ref.contrastClass,
      ariaLabel = _ref.ariaLabel,
      iconClass = _ref.iconClass,
      text = _ref.text;
  return "\n<button ".concat(ga ? "data-ga-track=\"wishlist\" data-ga-mediaID=\"".concat(ga.mediaId, "\" data-ga-type=").concat(ga.formatType) : '', "\nclass=\"WishListButton ").concat(contrastClass, "\" \ntype=\"button\" \naria-label=\"").concat(ariaLabel, "\">\n    <i class=\"").concat(iconClass, " icon animated bounceIn\" aria-hidden=\"true\"></i>\n    ").concat(text ? "<span class=\"u-allCaps WishListButton-text\">".concat(text, "</span>") : '', "\n</button>");
};

exports["default"] = _default;